@let isMobile = isMobileScreen();
@let rateplan = data();
@let localeObj = _storeSvc.localeObj();
@let isRateplanLoading = isLoading();

<!-- --------------------- Rateplan Images Carousel START ---------------------- -->
<ng-template #rateplanImgCarousel>
  @let images = rateplanImages();

  @if (images.length > 0) {
    <app-carousel [images]="images" [config]="carouselConfig()" />
  } @else if (rateplan?.extraThumbnailJumboImageUrl && rateplan?.extraThumbnailJumboImageUrl?.length > 0) {
    <img
      class="rateplan-img w-100 h-100"
      [src]="rateplan?.extraThumbnailJumboImageUrl"
      [alt]="rateplan?.imageAltText || rateplan?.name"
      onerror="this.src = '/assets/images/offers-blank.png'"
    />
  } @else {
    <img
      class="rateplan-fallback-img w-100 h-100"
      src="/assets/images/offers-blank.png"
      [attr.alt]="rateplan?.name + ' Blank Image'"
    />
  }
</ng-template>
<!-- ---------------------- Rateplan Images Carousel END ----------------------- -->

<!-- ------------------------- Rateplan Info START ------------------------- -->
<ng-template #ratePlanInfoTemplate let-rateplan>
  <div
    class="rateplan-info d-flex flex-column align-items-start"
    [class]="{
      'is-mobile': isMobile || (isPromoRate() && !isMobile),
      'w-100': isMobile || (isPromoRate() && !isMobile),
    }"
  >
    @let ratePlanName =
      rateplan?.isPreLoginOffer
        ? localeObj?.tf_2_RoomList_MembersRate_Label + ' - ' + (rateplan?.offerName || rateplan?.name)
        : rateplan?.offerName || rateplan?.name;

    @if (isRateplanLoading) {
      <div class="rateplan-name-skeleton w-100 mb-3">
        <app-skeleton-loader-item
          [count]="1"
          [width]="'100%'"
          [fullWidth]="true"
          [height]="'2.5rem'"
          [borderRadius]="'4px'"
          [marginBottom]="'0'"
        />
      </div>
    } @else {
      <h3 class="rateplan-name mb-3" [innerHTML]="ratePlanName | safeHtml"></h3>
    }

    @if (!isMobile && isRateplanLoading) {
      <div class="rateplan-description-skeleton w-100 mb-4">
        <app-skeleton-loader-item
          [count]="1"
          [width]="'100%'"
          [fullWidth]="true"
          [height]="'1rem'"
          [borderRadius]="'4px'"
          [marginBottom]="'0.75rem'"
        />
        <app-skeleton-loader-item
          [count]="1"
          [width]="'100%'"
          [fullWidth]="true"
          [height]="'1rem'"
          [borderRadius]="'4px'"
          [marginBottom]="'0.75rem'"
        />
        <app-skeleton-loader-item
          [count]="1"
          [width]="'75%'"
          [fullWidth]="true"
          [height]="'1rem'"
          [borderRadius]="'4px'"
          [marginBottom]="'0'"
        />
      </div>
    } @else if (!isMobile && !isSpecialRate() && !isPromoRate() && rateplan.shortDescription) {
      <p class="rateplan-description mb-4" [innerHTML]="rateplan.shortDescription | safeHtml"></p>
    } @else if (!isMobile && (isSpecialRate() || isPromoRate()) && rateplan.description) {
      <p class="rateplan-description mb-4" [innerHTML]="rateplan.description | safeHtml"></p>
    }

    @if (isRateplanLoading) {
      <div class="rateplan-details-link-skeleton w-100">
        <app-skeleton-loader-item
          [count]="1"
          [width]="'40%'"
          [fullWidth]="true"
          [height]="'2.5rem'"
          [borderRadius]="'var(--button-border-radius)'"
          [marginBottom]="'0'"
        />
      </div>
    } @else {
      <div [id]="'rateplan-details-link-' + rateplan.code">
        <app-button
          variant="link"
          [label]="
            isSpecialRate() || isPromoRate()
              ? localeObj?.tf_2_RoomList_viewofferDetails_link
              : localeObj?.tf_2_RoomList_viewRateDetails_link
          "
          (onClickEvent)="openRateplanDetails(true)"
        />
      </div>
    }
  </div>
</ng-template>
<!-- -------------------------- Rateplan Info END -------------------------- -->

<!-- ----------------------- Rateplan Pricing START ------------------------ -->
<ng-template #ratePlanPricingTemplate let-rateplan>
  <div
    class="rateplan-price-details d-flex"
    [class.w-100]="isMobile || (isPromoRate() && !isMobile)"
    [class.flex-column]="!isMobile && !isPromoRate()"
    [class.justify-content-center]="!isMobile"
    [class.flex-row]="isMobile || (!isMobile && isPromoRate())"
    [class.justify-content-between]="isMobile"
    [class.align-items-center]="isMobile || (isPromoRate() && !isMobile)"
    [class.gap-4]="isMobile"
    [class.pt-0]="isPromoRate() && !isMobile"
  >
    <div class="rateplan-price-details-content w-100" [class.mb-4]="!isMobile && !isPromoRate()">
      @let pricingData = pricing();
      @let pricingType =
        _storeSvc.propInfo()?.showAverageNightlyRate
          ? localeObj?.tf_2_RoomList_roomDetails_perNight
          : localeObj?.tf_2_RoomList_roomDetails_perStay;

      @let discountedPrice =
        _storeSvc.getDiscountedRatePlanPrice(
          data() || {},
          _storeSvc.currConf()?.code,
          _shoppingCartSvc.showTaxesInDisplayPrice()
        );

      @let avgPrice =
        _storeSvc.getAvgRatePlanPrice(data() || {}, _storeSvc.currConf()?.code, _shoppingCartSvc.showTaxesInDisplayPrice());

      @if (isRateplanLoading) {
        <div class="from-price-row-skeleton w-100 mb-1">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'75%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else if (
        (!isSpecialRate() && !isPromoRate() && !isRateplanLoading) ||
        ((isSpecialRate() || isPromoRate()) && !isRateplanLoading && rateplan?.isBookable)
      ) {
        <div class="from-price-row mb-1">
          @if (pricingData?.hasAvgRate) {
            <span class="sr-only" [innerHTML]="localeObj.tf_3_MultiRoom_checkinSummery_ADA_Original_price"></span>
          }
          @if (!pricingData?.hasComplimentaryRate && !pricingData?.hasPartialCompRate) {
            <span class="from-price-label" [innerHTML]="localeObj?.tf_2_RoomList_roomDetails_fromPrice"></span>
          }
          @if (showStrikeoutprice() && discountedPrice > 0 && avgPrice > discountedPrice) {
            <del class="from-price-value" [innerHTML]="_storeSvc.priceFormat(avgPrice)"></del>
          }
        </div>
      }

      @if (isRateplanLoading) {
        <div class="actual-price-row-skeleton w-100 mb-1">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [fullWidth]="true"
            [height]="'2rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else if ((isSpecialRate() || isPromoRate()) && !isRateplanLoading && !rateplan?.isBookable) {
        <div class="offer-not-available-row">
          <p
            class="offer-not-available mb-0"
            [innerHTML]="localeObj?.tf_6_MultiSpecials_text_offerNotAvailable | safeHtml"
          ></p>
        </div>
      } @else {
        <div class="actual-price-row d-flex align-items-center flex-wrap gap-1 mb-1">
          <span class="sr-only" [innerHTML]="localeObj?.tf_3_MultiRoom_checkinSummery_ADA_Current_price"> </span>
          <div class="d-flex align-items-center">
            @if (pricingData?.isFullComp || pricingData?.isPartialComp) {
              <img
                class="complimentary-icon"
                [src]="_storeSvc.complimentaryIcon()"
                [alt]="localeObj?.tf_2_RoomList_Complimentary_text"
              />
            }
            @if (pricingData?.isFullComp) {
              <span class="large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_Complimentary_text"> </span>
            } @else if (pricingData?.isPartialComp) {
              <span class="default-font-size pb-3" [innerHTML]="localeObj?.tf_2_RoomList_availableComplimentaryNight_text"></span>
            } @else {
              @if (pricingData?.hasComplimentaryRate || pricingData?.hasPartialCompRate) {
                <img
                  class="complimentary-icon"
                  [src]="_storeSvc.complimentaryIcon()"
                  [alt]="localeObj?.tf_2_RoomList_Complimentary_text"
                />
              }
              @if (pricingData?.hasComplimentaryRate) {
                <span class="large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_Complimentary_text"> </span>
              } @else if (pricingData?.hasPartialCompRate) {
                <span class="default-font-size pb-3" [innerHTML]="localeObj?.tf_2_RoomList_availableComplimentaryNight_text">
                </span>
              } @else {
                @if (data().isLoyaltyRate && !data().hasComplimentaryNight && !data().isFullyComplimentary) {
                  <img class="loyalty-icon" [src]="_storeSvc.propInfo().loyaltyIcon" [alt]="'Loyalty Rate'" />
                }
                <span
                  class="actual-price-value price-color"
                  [innerHTML]="_storeSvc.priceFormat(discountedPrice || avgPrice)"
                >
                </span>
                <span class="pricing-type" [innerHTML]="pricingType"></span>
              }
            }
          </div>
        </div>
      }

      @if (isRateplanLoading) {
        <div class="tax-msg-row-skeleton w-100 mb-3">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else if (!isRateplanLoading && !isSpecialRate() && !isPromoRate()) {
        <div class="tax-msg-row mb-3">
          <span class="tax-msg-label" [innerHTML]="pricingData?.taxDisplay"></span>
        </div>
      }

      @let dprTagLine = rateplan?.dprTagLine;
      @if (isRateplanLoading && showDPRMessage() && !isSpecialRate() && !isPromoRate()) {
        <div class="dpr-row-skeleton w-100">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'75%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else if (!isRateplanLoading && showDPRMessage() && dprTagLine) {
        <div class="dpr-row">
          <app-tag tagId="dpr" variant="success" icon="fa fa-badge-percent" [label]="dprTagLine" />
        </div>
      }
    </div>

    @if (isRateplanLoading) {
      <div class="rateplan-action-skeleton w-100">
        <app-skeleton-loader-item
          [count]="1"
          [width]="isMobile ? '100%' : '75%'"
          [fullWidth]="true"
          [height]="'2.5rem'"
          [borderRadius]="'var(--button-border-radius)'"
          [marginBottom]="'0'"
        />
      </div>
    } @else if (!isRateplanLoading && (isSpecialRate() || isPromoRate()) && !rateplan?.isBookable) {
      <div class="rateplan-action col-auto">
        <app-button
          variant="secondary"
          [variant]="'primary'"
          [label]="localeObj?.tf_6_MultiSpecials_button_selectDates"
          (onClickEvent)="editDates(rateplan)"
        />
      </div>
    } @else {
      <div class="rateplan-action col-auto">
        <app-button
          [variant]="isExpanded() ? 'secondary' : 'primary'"
          [label]="!isMobile && isExpanded() ? localeObj?.tf_2_RoomList_hideRooms : localeObj?.tf_2_RoomList_viewRooms"
          (onClickEvent)="!isMobile && isExpanded() ? hideItems() : viewItems()"
          [isDisabled]="isAddToCartInProgress()"
          [isLoading]="!isMobile && isItemsLoading()"
        />
      </div>
    }
  </div>
</ng-template>
<!-- ------------------------ Rateplan Pricing END ------------------------- -->

<app-card
  @grow
  [class.expanded]="isExpanded()"
  classes="w-100 card-room-rate-card"
  [padding]="0"
  [marginBottom]="1.5"
  [active]="!isMobile && isExpanded()"
>
  <!-- --------------------------- Rateplan Card START --------------------------- -->
  <div
    class="rateplan-card d-flex"
    [class.active]="isExpanded()"
    [class.flex-row]="!isMobile"
    [class.flex-column]="isMobile"
    [class.opacity-50]="(!isExpanded() && isAddToCartInProgress() && isDisabled()) || (!isExpanded() && isDisabled())"
    [class.pe-none]="(!isExpanded() && isAddToCartInProgress() && isDisabled()) || (!isExpanded() && isDisabled())"
    [class.is-mobile]="isMobile"
  >
    <div
      class="rateplan-images overflow-hidden"
      [ngClass]="{
        'border-top-radius w-100': isMobile,
        'border-left-radius': !isMobile,
        'w-75': isPromoRate() && !isMobile,
      }"
      (click)="openRateplanDetails()"
      role="button"
    >
      @if (isRateplanLoading) {
        <div class="rateplan-images-skeleton w-100 h-100">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [height]="isMobile ? '200px' : '100%'"
            [fullHeight]="true"
            [fullWidth]="true"
          />
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="rateplanImgCarousel" />
      }
    </div>

    @if (isPromoRate() && !isMobile) {
      <div class="promo-rate-details w-100">
        <ng-container [ngTemplateOutlet]="ratePlanInfoTemplate" [ngTemplateOutletContext]="{ $implicit: rateplan }" />

        <ng-container
          [ngTemplateOutlet]="ratePlanPricingTemplate"
          [ngTemplateOutletContext]="{ $implicit: rateplan }"
        />
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="ratePlanInfoTemplate" [ngTemplateOutletContext]="{ $implicit: rateplan }" />

      <ng-container [ngTemplateOutlet]="ratePlanPricingTemplate" [ngTemplateOutletContext]="{ $implicit: rateplan }" />
    }
  </div>

  @if (isExpanded() && !isMobile && items().length > 0) {
    <div class="room-rates-container" [style.padding.rem]="isMobile ? 1.25 : 2.5" @grow>
      @for (item of items(); track index; let index = $index; let isLast = $last) {
        <app-room-card
          [isChild]="true"
          [index]="index"
          [data]="item"
          [noPadding]="true"
          [noBorder]="true"
          [noMarginBottom]="true"
          [isAddToCartInProgress]="item?.code === selectedRoomCode() && isAddToCartInProgress()"
          [isDisabled]="item?.code !== selectedRoomCode() && isAddToCartInProgress()"
          (onItemSelected)="onRoomSelected($event)"
        />

        @if (!isLast) {
          <hr class="room-rates-separator opacity-100" />
        }
      }
    </div>
  }
  <!-- ---------------------------- Rateplan Card END ---------------------------- -->
</app-card>

<!-- ------------------ Rateplan Rooms List for Mobile START ------------------- -->
<ng-template #rateplanRoomsListContent>
  <div class="rateplan-rooms-list-mobile-content">
    <div class="rateplan-images position-relative">
      <ng-container [ngTemplateOutlet]="rateplanImgCarousel" />
      <app-button
        class="rateplan-rooms-list-mobile-close-btn"
        variant="close"
        label="Close Button"
        (onClickEvent)="closeRateplanRoomsListMobile()"
        [classes]="'neutral-white-color-bg'"
      />
    </div>

    <div class="rateplan-info s-p-20">
      <h2 class="rateplan-name s-mb-16">{{ rateplan?.name }}</h2>

      <div [id]="'rateplan-details-link-' + rateplan.code">
        <app-button
          variant="link"
          [label]="localeObj?.tf_2_RoomList_viewRateDetails_link"
          (onClickEvent)="openRateplanDetails()"
        />
      </div>
    </div>

    <div class="rateplan-rooms-list d-flex flex-column s-pt-12 s-pb-20 s-px-20">
      @if (isItemsLoading()) {
        @for (item of [0, 1, 2]; track index; let index = $index; let isLast = $last) {
          <app-room-card
            [isLoading]="true"
            [isChild]="true"
            [index]="index"
            [data]="item"
            [noMarginBottom]="isLast"
            [isAddToCartInProgress]="item?.code === selectedRoomCode() && isAddToCartInProgress()"
            [isDisabled]="item?.code !== selectedRoomCode() && isAddToCartInProgress()"
          />
        }
      } @else {
        @for (item of items(); track index; let index = $index; let isLast = $last) {
          <app-room-card
            [isChild]="true"
            [index]="index"
            [data]="item"
            [noMarginBottom]="isLast"
            [isAddToCartInProgress]="item?.code === selectedRoomCode() && isAddToCartInProgress()"
            [isDisabled]="item?.code !== selectedRoomCode() && isAddToCartInProgress()"
            (onItemSelected)="onRoomSelected($event)"
          />
        }
      }
    </div>
  </div>
</ng-template>
<!-- ------------------- Rateplan Rooms List for Mobile END -------------------- -->

<!-- ---------------------- Rate Details START ----------------------- -->
<ng-template #rateplanDetailsContent>
  @if (rateplan?.longDescription) {
    <div class="s-pb-32">
      <span [innerHTML]="rateplan?.longDescription | safeHtml"></span>
    </div>
  }

  @if (rateplan?.policyDetails?.policies[0]?.cancellationPolicy) {
    <div>
      <h5 class="s-mb-12" [innerHTML]="localeObj?.tf_04_Checkout_payment_cancellation_policies"></h5>
      <span [innerHTML]="rateplan?.policyDetails?.policies[0]?.cancellationPolicy | safeHtml"></span>
    </div>
  }
</ng-template>

<!-- ----------------------- Rate Details END ------------------------ -->

<app-side-panel [id]="'rateplan-details-side-panel'" [title]="data()?.name" />

<app-side-panel [id]="'rateplan-rooms-list-side-panel'" [fullMaxHeight]="true" [hideHeader]="true" />
